var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(Object.keys(_vm.accounts).length)?[_vm._l((_vm.accounts),function(account){return [(_vm.link)?[_c('router-link',{key:account.id,attrs:{"to":{
            name: 'Account',
            params: { account: account.accountNumber },
          }}},[_c('button',{staticClass:"pushable",on:{"click":_vm.sendClickEvt}},[_c('span',{staticClass:"shadow"}),_c('span',{staticClass:"edge"}),_c('span',{staticClass:"front"},[_c('account',{attrs:{"account":account}})],1)])])]:[_c('account',{key:account.id,attrs:{"account":account}})]]})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }